import React, { useState, useRef ,useEffect} from 'react';
import { ReactTabulator } from 'react-tabulator';
import DatePicker from "react-datepicker";
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import moment from 'moment';
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// 베트남 동 통화로 변환하는 함수
function formatMoney(amount) {
	return new Intl.NumberFormat('vi-VN', {
		style    : 'currency',
		currency : 'VND',
	}).format(amount).replace(/[₫]/g,'').trim(); // 통화 기호만 제거
};

// 대출잔고
const titleColumns = (t) => {
	return [
			{ title: t('REPORT.구분', { defaultValue: '구분' }), field: 'code_name', headerHozAlign: 'center', hozAlign: 'center', width: 160 },
			{
				title: t(`REPORT.전월말`, { defaultValue: '전월말' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'total_cnt_1', headerHozAlign: 'center',hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					// { title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_1', headerHozAlign: 'center', hozAlign: 'right', width : 160, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false }, width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_1', headerHozAlign: 'center', hozAlign: 'right', width : 195, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, //, width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.전일`, { defaultValue: '전일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'total_cnt_2', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					// { title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_2', headerHozAlign: 'center', hozAlign: 'right', width : 140, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false }, width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_2', headerHozAlign: 'center', hozAlign: 'right', width : 195, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false }, },  //width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.당일`, { defaultValue: '당일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'total_cnt_3', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_3', headerHozAlign: 'center', hozAlign: 'right', width : 195, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.전일대비`, { defaultValue: '전일대비' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'total_cnt_4', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_4', headerHozAlign: 'center', hozAlign: 'right', width : 195, formatter:"money", formatterParams:{ decimal:",", thousand:".",  precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } }, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.전월대비`, { defaultValue: '전월대비' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'total_cnt_5', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'total_balance_5', headerHozAlign: 'center', hozAlign: 'right', width : 195, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } }, // 금액 컬럼
				],
			},
			
	];
};

// 연체현황(대출잔액)
const titleColumns2 = (t) => {
	return [
			{ title: t('REPORT.구분', { defaultValue: '구분' }), field: 'collateral_name', headerHozAlign: 'center', hozAlign: 'center', width: 160 },
			{
				title: t(`REPORT.1~5일`, { defaultValue: '1~5일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt1', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_balance1', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per1', 
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.6일~30일`, { defaultValue: '6일~30일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt2', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_balance2', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per2',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.31일~60일`, { defaultValue: '31일~60일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt3', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_balance3', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per3', 
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.61일~`, { defaultValue: '61일~' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt4', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_balance4', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per4',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.합계`, { defaultValue: '합계' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'tot_cnt', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'tot_sum_balance', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'tot_per',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			
	];
};

// 연체현황(미납금액-구분별)
const titleColumns3 = (t) => {
	return [
		// gubun_section_name 
		{ title: t('REPORT.구분', { defaultValue: '구분' }), field: 'gubun_section_name', headerHozAlign: 'center', hozAlign: 'center', width: 180 },
			{
				title: t(`REPORT.1~5일`, { defaultValue: '1~5일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }),  field: 'cnt1', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }),  field: 'sum_overdue1', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }),  field: 'per1', formatter:"money",
					// formatterParams: {
					// 	decimal: ".",
					// 	thousand: ",",
					// 	symbolAfter: "%",
					// 	negativeSign: true,
					// 	precision: false,
					// },
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center',
					hozAlign: 'right',
					width: 75}, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.6일~30일`, { defaultValue: '6일~30일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt2', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_overdue2', headerHozAlign: 'right', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per2',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75}, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.31일~60일`, { defaultValue: '31일~60일' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt3', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_overdue3', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'per3',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.61일~`, { defaultValue: '61일~' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'cnt4', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'sum_overdue4', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'tot_per',
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			{
				title: t(`REPORT.합계`, { defaultValue: '합계' }), // 전월말 컬럼 헤더
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.건수`, { defaultValue: '건수' }), field: 'tot_cnt', headerHozAlign: 'center', hozAlign: 'right', width : 100, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' }), field: 'tot_sum_overdue', headerHozAlign: 'center', hozAlign: 'right', width : 120, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.연체율`, { defaultValue: '연체율' }), field: 'tot_per', 
					formatter: (cell, formatterParams, onRendered) => {
						const value = cell.getValue();
						const formattedValue = `${parseFloat(value).toFixed(2)}%`;
        				return formattedValue;
					},
					headerHozAlign: 'center', hozAlign: 'right' ,width: 75},
				],
			},
			
	];
};

// 신규 취급현황(상품별)
const titleColumns4 = (t) => {
	return [
		// gubun_section_name 
			{ title: t('REPORT.구분', { defaultValue: '구분' }), field: 'item_name', headerHozAlign: 'center', hozAlign: 'center', width: 120 },
			{
				title: t(`REPORT.일계-신규`, { defaultValue: '일계-신규' }), 
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.대출건수`, { defaultValue: '대출건수' }), field: 'cnt1_x', headerHozAlign: 'center', hozAlign: 'right', width : 235, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`LOAN_DISBURSEMENT.대출금액`, { defaultValue: '대출금액' }), field: 'sum_loan_amount_x', headerHozAlign: 'center', hozAlign: 'right', width : 300, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.승인단가`, { defaultValue: '승인단가' }), field: '', headerHozAlign: 'center', hozAlign: 'right' ,width: 200}, // 금액 컬럼
				],
			},
			{
				title: t(`REPORT.월계-신규`, { defaultValue: '월계-신규' }), 
				headerHozAlign: 'center',
				columns: [
					{ title: t(`REPORT.대출건수`, { defaultValue: '대출건수' }), field: 'cnt1_y', headerHozAlign: 'center', hozAlign: 'right', width : 235, bottomCalc: "sum" }, // 건수 컬럼
					{ title: t(`LOAN_DISBURSEMENT.대출금액`, { defaultValue: '대출금액' }), field: 'sum_loan_amount_y', headerHozAlign: 'center', hozAlign: 'right', width : 300, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
					{ title: t(`REPORT.승인단가`, { defaultValue: '승인단가' }), field: '', headerHozAlign: 'center', hozAlign: 'right' ,width: 200}, // 금액 컬럼
				],
			},			
	];
};

// 신규 취급현황(지점별)
const titleColumns5 = (t) => {
	return [
		// gubun_section_name 
		{ title: t('REPORT.구분', { defaultValue: '구분' }), field: 'branch_name', headerHozAlign: 'center', hozAlign: 'center', width: 120 },
		{
			title: t('REPORT.일계-신규', { defaultValue: '일계-신규' }), // 전월말 컬럼 헤더
			headerHozAlign: 'center',
			columns: [
				{ title: t(`REPORT.대출건수`, { defaultValue: '대출건수' }), field: 'cnt1_x', headerHozAlign: 'center', hozAlign: 'right', width : 235, bottomCalc: "sum" }, // 건수 컬럼
				{ title: t(`LOAN_DISBURSEMENT.대출금액`, { defaultValue: '대출금액' }), field: 'sum_loan_amount_x', headerHozAlign: 'right', hozAlign: 'right', width : 300, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
				{ title: t(`REPORT.승인단가`, { defaultValue: '승인단가' }), field: 'per1', headerHozAlign: 'center', hozAlign: 'right' ,width: 200}, // 금액 컬럼
			],
		},
		{
			title: t('REPORT.월계-신규', { defaultValue: '월계-신규' }), // 전월말 컬럼 헤더
			headerHozAlign: 'center',
			columns: [
				{ title: t(`REPORT.대출건수`, { defaultValue: '대출건수' }), field: 'cnt1_y', headerHozAlign: 'center', hozAlign: 'right', width : 235, bottomCalc: "sum" }, // 건수 컬럼
				{ title: t(`LOAN_DISBURSEMENT.대출금액`, { defaultValue: '대출금액' }), field: 'sum_loan_amount_y', headerHozAlign: 'right', hozAlign: 'right', width : 300, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } }, // 금액 컬럼
				{ title: t(`REPORT.승인단가`, { defaultValue: '승인단가' }), field: 'per2', headerHozAlign: 'center', hozAlign: 'right' ,width: 200}, // 금액 컬럼
			],
		},	
			
	];
};

// 영업일보
const Report001 = () => {
	const { t ,i18n }          				    = useTranslation();
	const [loading, setLoading]                 = useState(false);
	const yesterday = new Date();
	yesterday.setDate(yesterday.getDate() - 1); //어제날짜를 구함

	const [workdate, setWorkdate]               = useState(yesterday);
	const tableRef    					        = useRef(null);
	const userInfo                              = getUserInfo(store.getState());
	const [branchType, setBranchType]           = useState(userInfo.branch_type);
	const [responseData1, setResponseData1]     = useState([]);
	const [responseData2, setResponseData2]     = useState([]);
	const [responseData3, setResponseData3]     = useState([]);
	const [responseData4, setResponseData4]     = useState([]);

	const [responseData4_1, setResponseData4_1] = useState([]); 	//신규 일,월계값
	const [responseData4_2, setResponseData4_2] = useState([]);		//재대출 일,월계값
	const [responseData4_3, setResponseData4_3] = useState([]);		//대출합계 일,월계값

	const [responseData4_4, setResponseData4_4] = useState([]);		//원금감소 일,월계값
	const [responseData4_5, setResponseData4_5] = useState([]);		//원금완제 일,월계값
	const [responseData4_6, setResponseData4_6] = useState([]);		//원금합계 일,월계값

	const [responseData4_7, setResponseData4_7] = useState([]);		//입금금액총계 일,월계값
	
	const [feeData, setFeeData] 		 	 	= useState([]);		//수수료 일,월계값
	// const [feeTotalData, setTotalFeeData] 		 	 	= useState([]);		//수입합계 일,월계값
	const [feeTotalData, setTotalFeeData]       = useState({
		cnt1_x: 0,
		cnt1_y: 0,
		sum_loan_amount_x: 0,
		sum_loan_amount_y: 0,
	});

	//지점 정보 selectBox 기본값
	const [SelectOptions1,setSelectOptions1]    = useState([]);
	const [selectBranch,setSelectBranch]        = useState('');
	const [responseData5, setResponseData5]     = useState([]);
	const [responseData6, setResponseData6]     = useState([]);
	const [rowsPerPage, setRowsPerPage]         = useState(20);

	const [columns,  setColumns]                = useState(titleColumns(t));
	const [columns2, setColumns2]               = useState(titleColumns2(t));
	const [columns3, setColumns3]               = useState(titleColumns3(t));
	const [columns4, setColumns4]               = useState(titleColumns4(t));
	const [columns5, setColumns5]               = useState(titleColumns5(t));
	
	const rowCount                              = feeData.length + 5; // feeData의 행 개수에 5를 더하여 rowCount 계산

	//수수료 table을 그리기 위한
	const feeTableRows = () => {
	
		return feeData.map((item, index) => (
			<tr key={index}>									
				<td className="bg-white border h-12">
					<div className="text-right mb-2 mt-2 ms-2">{item.item_name}</div>
				</td>
				<td className="bg-white border h-12 col-span-2 text-center">
					<div className="text-right mb-2 mt-2">{item.cnt1_x !== "" ? item.cnt1_x : 0}</div>
				</td>
				<td className="bg-white border h-12 text-end">
					<div className="text-right mb-2 mt-2 me-2">{formatMoney(item.sum_loan_amount_x !== "" ? item.sum_loan_amount_x : 0)}</div>
				</td>
				<td className="bg-white border h-12 col-span-2 text-center">
					<div className="text-right mb-2 mt-2">{item.cnt1_y !== "" ? item.cnt1_y : 0}</div>
				</td>
				<td className="bg-white border h-12  text-end style={{ width: '200px' }}">
					<div className="text-right mb-2 mt-2 me-2">{formatMoney(item.sum_loan_amount_y !== "" ? item.sum_loan_amount_y : 0)}</div>
				</td>																	
				<td className="bg-white border h-12">
					<div className="text-right mb-2 mt-2"></div>
				</td>																	
			</tr>
		));
	};

	const fetchBaseOptions = async () => {			
		try {
			const data           = await API.fetchBaseOptions();
			const options1       = data.filter(item => item.code_nick_name === '지점');
			const SelectOptions1 = options1.map(item => [item.code,item.code_se]);
			
			setSelectOptions1(SelectOptions1);

			if (SelectOptions1.length === 1) {
				setSelectBranch(SelectOptions1[0][0]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	//수익합계 
	const feeDataChange = () => {
		let totalCnt1_x = 0;
		let totalCnt1_y = 0;
		let totalSumLoanAmount_x = 0;
		let totalSumLoanAmount_y = 0;

		feeData.forEach((item) => {
			totalCnt1_x += item.cnt1_x || 0;
			totalCnt1_y += item.cnt1_y || 0;
			totalSumLoanAmount_x += item.sum_loan_amount_x || 0;
			totalSumLoanAmount_y += item.sum_loan_amount_y || 0;
		});

		setTotalFeeData({
			cnt1_x: totalCnt1_x,
			cnt1_y: totalCnt1_y,
			sum_loan_amount_x: totalSumLoanAmount_x,
			sum_loan_amount_y: totalSumLoanAmount_y,
		});
	};

	// 조회 리팩토링
	const fetchData = async (apiFunction, stateSetter) => {
		try {
			const response = await apiFunction;
			stateSetter(response);

			return response;
		} catch (error) {
			console.error('Error in fetchData:', error);
			return null;
		}
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = async () => {
		setLoading(true);

		// ①. 대출잔고
		const response1 = await fetchData(
			API.fetchReport001Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),
			setResponseData1
		);

		if (response1) {
			const modifiedResponse1 = response1.map(item => {
				for (let i = 1; i <= 5; i++) {
					const balanceProp = `total_balance_${i}`;
					const cntProp     = `total_cnt_${i}`;
										
					if (item[balanceProp] === null) {
						item[balanceProp] = 0;
					}

					if (item[cntProp] === null) {
						item[cntProp] = 0;
					}
				}
				item['code_name'] = t(`COLLATERAL.${item['code']}`,{ defaultValue: item['code_name'] })
				return item;
			});

			setResponseData1(modifiedResponse1);
		};

		// ②. 연체현황 (대출잔액)
		const response2 = await fetchData(
			API.fetchReport002Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),
			setResponseData2
		);
			if(response2){
			const modifiedResponse2 = response2.map(item => {
				item['collateral_name'] = t(`COLLATERAL.${item['collateral_type']}`,{ defaultValue: item['collateral_name'] })
				return item;
			});

			setResponseData2(modifiedResponse2);
		};

		// ③. 연체현황 (미납금액)
		const response3 = await fetchData(
			API.fetchReport003Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),	
			setResponseData3
		);

		if(response3){
			const modifiedResponse3 = response3.map(item => {
				item['gubun_section_name'] = t(`LOAN_RECEIVABLE_INQUIRY.${item['gubun_section_name']}`,{ defaultValue: item['gubun_section_name'] })
				// console.log('gubun_section_name  ' + item['gubun_section_name'])
				return item;
			});
		
			setResponseData3(modifiedResponse3)
		};

		// ④. 영업현황
		const response4 = await fetchData(
			API.fetchReport004Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),
			setResponseData4
		);
		if(response4){
			const modifiedResponse3 = response4.map(item => {
				item['item_name'] = t(`LOAN_RECEIVABLE_INQUIRY.${item['item_name']}`,{ defaultValue: item['item_name'] })
				// console.log('item_name  ' + item['item_name'])
				return item;
			});
		
			setResponseData4(modifiedResponse3)
		};
		const newData     = response4.find(item => item.loan_id === '11');
		const reloanData  = response4.find(item => item.loan_id === '12');
		const minPrinData = response4.find(item => item.loan_id === '13');
		const comPrinData = response4.find(item => item.loan_id === '14');
		
		//대출합계
		const loanTotal = {
			cnt1_x	 		  : ((newData && newData.cnt1_x !== "") ? newData.cnt1_x : 0) + ((reloanData && reloanData.cnt1_x !== "") ? reloanData.cnt1_x : 0),
			sum_loan_amount_x : (newData ? newData.sum_loan_amount_x : 0) + (reloanData ? reloanData.sum_loan_amount_x : 0),
			cnt1_y			  : ((newData && newData.cnt1_y !== "") ? newData.cnt1_y : 0) + ((reloanData && reloanData.cnt1_y !== "") ? reloanData.cnt1_y : 0),
			sum_loan_amount_y : (newData ? newData.sum_loan_amount_y : 0) + (reloanData ? reloanData.sum_loan_amount_y : 0),
		};
		
		//원금합계
		const prinTotal = {
			cnt1_x			  : ((minPrinData && minPrinData.cnt1_x !== "") ? minPrinData.cnt1_x : 0) + ((comPrinData && comPrinData.cnt1_x !== "") ? comPrinData.cnt1_x : 0),
			sum_loan_amount_x : (minPrinData ? minPrinData.sum_loan_amount_x : 0) + (comPrinData ? comPrinData.sum_loan_amount_x : 0),
			cnt1_y			  : ((minPrinData && minPrinData.cnt1_y !== "") ? minPrinData.cnt1_y : 0) + ((comPrinData && comPrinData.cnt1_y !== "") ? comPrinData.cnt1_y : 0),
			sum_loan_amount_y : (minPrinData ? minPrinData.sum_loan_amount_y : 0) + (comPrinData ? comPrinData.sum_loan_amount_y : 0),
		};

		// 대출
		setResponseData4_1(newData)
		setResponseData4_2(reloanData)
		setResponseData4_3(loanTotal)

		// 입금
		setResponseData4_4(minPrinData)
		setResponseData4_5(comPrinData)
		setResponseData4_6(prinTotal)

		// 고정 값들(신규, 재대출, 원금감소, 원금완제 완료 )

		// loan_id가 20번대인 값들을 가져옴(수수료) 25번은 제외함
		setFeeData(response4.filter(item => item.loan_id.startsWith('2') && !item.loan_id.startsWith('25')))

		setResponseData4(response4)

		// ⑤. 신규현황 (담보별)
		const response5 = await fetchData(
			API.fetchReport005Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),
			setResponseData5
		);
		if(response2){
			const modifiedResponse5 = response5.map(item => {
				item['item_name'] = t(`COLLATERAL.${item['collateral_type']}`,{ defaultValue: item['item_name'] })
				return item;
			});

			setResponseData5(modifiedResponse5);
		};

		// ⑥. 신규현황 (지점별)
		const response6 = await fetchData(
			API.fetchReport006Data({ 
				workdate    : moment(workdate).format('YYYY-MM-DD'),
				branch_code : selectBranch,
			}),
			setResponseData6
		);

		setLoading(false);
	};

	// 지점 옵션 조회
	useEffect(() => {
		const fetchOptionsAndQuery = async () => {
			await fetchBaseOptions();
		};
		fetchOptionsAndQuery();
	}, []);
	
	//수익합계 값
	useEffect(() => {				
		feeDataChange();
	}, [feeData]);

	// i18 언어에 맞춰서 자동 갱신 (컬럼명, Grid 내용)
	useEffect(() => {
		setColumns(titleColumns(t))
		setColumns2(titleColumns2(t))
		setColumns3(titleColumns3(t))
		setColumns4(titleColumns4(t))
		setColumns5(titleColumns5(t))
			}, [i18n.language, t]);

	// 조회
	useEffect(() => {
		handleQuery();
	}, [workdate, selectBranch,i18n.language, t]);

	// 시작일 값 변경
	const handleChangeWorkdate = (date) => {
		setWorkdate(date);
	};

	// 지점 정보 변경
	const handleChangeChannel = (e) => {
		setSelectBranch(e.target.value);
	};

	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t(`REPORT.영업일보`, { defaultValue: '영업일보' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					{/* <form action="/" method="POST"> */}
						<div className="row ms-0">
							<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="date_id">
									<i className="bi bi-calendar3"></i> {t(`REPORT.조회일`, { defaultValue: '조회일' })}
								</label>

								<div className="input-group input-daterange">
									<div className='col'>
										<DatePicker
											className='form-control'
											selected={workdate}
											onChange={handleChangeWorkdate}
											dateFormat="dd/MM/yyyy"
										/>
									</div>
								</div>
							</div>

							<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="site_code_id">
								<i className="bi bi-buildings "></i> {t('STAFF_MANAGEMENT.지점', { defaultValue: '지점' })}
							</label>

							<select onChange={handleChangeChannel} value={selectBranch} className="form-select" id="site_code_id">
								{branchType === 'HEAD' 
									? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
									: ''
								}
								{SelectOptions1.map((option, index) => (
									<option key={index} value={option[0]}>
										{/* {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })} */}
										{option[1]}											
									</option>
								))}
							</select>
						</div>
							<div className="form-group col-lg-6 col-md-12 col-xs-12"></div>

							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>
						</div>
						
						<h3 className='pt-3'>{t(`REPORT.대출잔고`, { defaultValue: '대출잔고' })}</h3>
						<ReactTabulator
							key={i18n.language + JSON.stringify(columns)}
							onRef={(r) => (tableRef.current = r.current)}
							columns={columns}
							data={responseData1}
							options={{
								layout      : "fitColumns",
								height      : "270px",
								placeholder : "No Data Found",
							}}
							className="responsive-tabulator"
						/>
						<hr></hr>

						<h3>{t(`REPORT.연체현황`, { defaultValue: '연체현황' })}</h3>
						<h5 className='p-2'>• {t(`REPORT.대출잔액`, { defaultValue: '대출잔액' })}</h5>
						<ReactTabulator
							key={i18n.language + JSON.stringify(columns2)}
							onRef={(r) => (tableRef.current = r.current)}
							columns={columns2} // 다중 헤더 배열을 flat() 함수로 평평하게 만들어 전달합니다.
							data={responseData2}
							options={{
								layout      : "fitColumns",
								height      : "270px",
								placeholder : "No Data Found",
							}}
							className="responsive-tabulator"
						/>
						{/* <hr></hr> */}

						<h5 className='p-2'>• {t(`REPORT.미납금액`, { defaultValue: '미납금액' })}</h5>
						<ReactTabulator
							key={i18n.language + JSON.stringify(columns3)}
							onRef={(r) => (tableRef.current = r.current)}
							columns={columns3} // 다중 헤더 배열을 flat() 함수로 평평하게 만들어 전달합니다.
							data={responseData3}
							options={{
								layout      : "fitColumns",
								height      : "270px",
								placeholder : "No Data Found",
							}}
							className="responsive-tabulator"
						/>
					<hr></hr>
					<h3>{t(`REPORT.영업현황`, { defaultValue: '영업현황' })}</h3>
						{/* <h5 className='p-2'>• 상품별</h5> */}
					<div className="panel-body" style={{width:'80%'}} >
						<table className="border-collapse border border-blue-gray-50" style={{ backgroundColor: '#EEF1F4',width: '-webkit-fill-available' }}>
							<thead>
								<tr>
									<th className="bg-blue-gray-50/50 border h-24" rowSpan="2" colSpan="2" style={{ width: '100px', verticalAlign: 'middle', textAlign: 'center' }}>
										<div className="text-center">{t(`REPORT.구분`, { defaultValue: '구분' })}</div>
									</th>
									<th className="bg-blue-gray-50/50 border h-12" colSpan="2" style={{ width: '250px', verticalAlign: 'middle', textAlign: 'center' }}>
										<div className="text-center mb-2 mt-2">{t(`REPORT.일계`, { defaultValue: '일계' })}</div>
									</th>
									<th className="bg-blue-gray-50/50 border h-12" colSpan="3" style={{ width: '250px', verticalAlign: 'middle', textAlign: 'center' }}>
										<div className="text-center mb-2 mt-2">{t(`REPORT.월계`, { defaultValue: '월계' })}</div>
									</th>								
									{/* <th className="bg-blue-gray-50/50 border h-12" colSpan="2" style={{ width: '200px', verticalAlign: 'middle', textAlign: 'center' }}>
										<div className="text-center"></div>
									</th>								 */}
								</tr>
								<tr>
									{/* 전월말의 건수, 금액 */}
									<th className="bg-blue-gray-50/50 border h-12" style={{ width: '100px'}}>
										<div className="text-center mb-2 mt-2">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
									</th>
									<th className="bg-blue-gray-50/50 border h-12" style={{ width: '200px'}}>
										<div className="text-center mb-2 mt-2">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
									</th>
									{/* 추가 헤더 1의 건수, 금액 */}
									<th className="bg-blue-gray-50/50 border h-12" style={{ width: '100px'}}>
										<div className="text-center mb-2 mt-2">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
									</th>
									<th className="bg-blue-gray-50/50 border h-12" style={{ width: '200px'}}>
										<div className="text-center mb-2 mt-2">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
									</th>
									
									<th className="bg-blue-gray-50/50 border h-12"style={{ width: '200px'}}>
										<div className="text-center mb-2 mt-2">{t(`REPORT.전월대비`, { defaultValue: '전월대비' })}</div>
									</th>										
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="bg-white border h-36" rowSpan="3">
										<div className="text-center mt-3 mr-2">{t(`REPORT.대출`, { defaultValue: '대출' })}</div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.신규`, { defaultValue: '신규' })}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_1 && responseData4_1.cnt1_x !== "") ? responseData4_1.cnt1_x : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end style={{ width: '200px' }}">
										<div className="mb-2 mt-2 me-2">{responseData4_1 ? formatMoney(responseData4_1.sum_loan_amount_x) : 0}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_1 && responseData4_1.cnt1_y !== "") ? responseData4_1.cnt1_y : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end style={{ width: '200px' }}">
										<div className="mb-2 mt-2 me-2">{responseData4_1 ? formatMoney(responseData4_1.sum_loan_amount_y) : 0}</div>
									</td>																	
									<td className="bg-white border h-12 text-end style={{ width: '200px' }}">
										{/* <div className="mb-2 mt-2 me-2">{responseData4_1 ? formatMoney(responseData4_1.sum_loan_amount_y/responseData4_1.cnt1_y) : 0}</div> */}
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>									
									<td className="bg-white border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.재대출`, { defaultValue: '재대출' })}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_2 && responseData4_2.cnt1_x !== "") ? responseData4_2.cnt1_x : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end style={{ width: '200px' }}">
										<div className="mb-2 mt-2 me-2">{responseData4_2 ? formatMoney(responseData4_2.sum_loan_amount_x) : 0}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_2 && responseData4_2.cnt1_y !== "") ? responseData4_2.cnt1_y : 0}</div>
									</td>
									<td className="bg-white border h-12  text-end style={{ width: '200px' }}">
										<div className="mb-2 mt-2 me-2">{responseData4_2 ? formatMoney(responseData4_2.sum_loan_amount_y) : 0}</div>
									</td>																	
									<td className="bg-white border h-12  text-end style={{ width: '200px' }}">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>									
									<td className="bg-blue-gray-50/50 border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.대출합계`, { defaultValue: '대출합계' })}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{responseData4_3 ? responseData4_3.cnt1_x : 0}</div>										
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney(responseData4_3.sum_loan_amount_x)}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{responseData4_3.cnt1_y}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney(responseData4_3.sum_loan_amount_y)}</div>
									</td>																	
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>
									<td className="bg-white border h-36" rowSpan={rowCount}>
										<div className="text-center mt-3 mr-2">{t(`REPORT.입금`, { defaultValue: '입금' })}</div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.원금감소`, { defaultValue: '원금감소' })}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_4 && responseData4_4.cnt1_x !== "") ? responseData4_4.cnt1_x : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{responseData4_4 ? formatMoney(responseData4_4.sum_loan_amount_x) : 0}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_4 && responseData4_4.cnt1_y !== "") ? responseData4_4.cnt1_y : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{responseData4_4 ? formatMoney(responseData4_4.sum_loan_amount_y) : 0}</div>
									</td>																	
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>									
									<td className="bg-white border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.완제`, { defaultValue: '완제' })}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_5 && responseData4_5.cnt1_x !== "") ? responseData4_5.cnt1_x : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{responseData4_5 ? formatMoney(responseData4_5.sum_loan_amount_x) : 0}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_5 && responseData4_5.cnt1_y !== "") ? responseData4_5.cnt1_y : 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{responseData4_5 ? formatMoney(responseData4_5.sum_loan_amount_y) : 0}</div>
									</td>																	
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>									
									<td className="bg-blue-gray-50/50 border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.원금합계`, { defaultValue: '원금합계' })}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{responseData4_6.cnt1_x}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney(responseData4_6.sum_loan_amount_x)}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{responseData4_6.cnt1_y}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney(responseData4_6.sum_loan_amount_y)}</div>
									</td>																	
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								{feeTableRows()}
								<tr>									
									<td className="bg-blue-gray-50/50 border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.수익합계`, { defaultValue: '수익합계' })}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{feeTotalData ? feeTotalData.cnt1_x : 0}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{feeTotalData ? formatMoney(feeTotalData.sum_loan_amount_x) : 0}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{feeTotalData ? feeTotalData.cnt1_y : 0}</div>
									</td>
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{feeTotalData ? formatMoney(feeTotalData.sum_loan_amount_y) : 0}</div>
									</td>																	
									<td className="bg-blue-gray-50/50 border h-12 text-end">
										<div className="mb-2 mt-2"></div>
									</td>																	
								</tr>
								<tr>									
									<td className="bg-white border h-12">
										<div className="text-right mb-2 mt-2 ms-2">{t(`REPORT.입금금액총계`, { defaultValue: '입금금액총계' })}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_6 ? responseData4_6.cnt1_x : 0) + (feeTotalData.cnt1_x !== "" ? feeTotalData.cnt1_x : 0) || 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney((responseData4_6.sum_loan_amount_x !== "" ? responseData4_6.sum_loan_amount_x : 0) + (feeTotalData.sum_loan_amount_x !== "" ? feeTotalData.sum_loan_amount_x : 0)) || 0}</div>
									</td>
									<td className="bg-white border h-12 col-span-2 text-center">
										<div className="mb-2 mt-2">{(responseData4_6.cnt1_y !== "" ? responseData4_6.cnt1_y : 0) + (feeTotalData.cnt1_y !== "" ? feeTotalData.cnt1_y : 0) || 0}</div>
									</td>
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2">{formatMoney((responseData4_6.sum_loan_amount_y !== "" ? responseData4_6.sum_loan_amount_y : 0) + (feeTotalData.sum_loan_amount_y !== "" ? feeTotalData.sum_loan_amount_y : 0)) || 0}</div>
									</td>																	
									<td className="bg-white border h-12 text-end">
										<div className="mb-2 mt-2 me-2"></div>
									</td>																	
								</tr>
							</tbody>
						</table>
					</div>
					<hr></hr>
					<h3>{t(`REPORT.신규취급현황`, { defaultValue: '신규취급현황' })}</h3>
						<h5 className='p-2'>• {t(`REPORT.상품별`, { defaultValue: '상품별' })}</h5>
						<ReactTabulator
							key={i18n.language + JSON.stringify(columns4)}
							onRef={(r) => (tableRef.current = r.current)}
							columns={columns4} // 다중 헤더 배열을 flat() 함수로 평평하게 만들어 전달합니다.
							data={responseData5}
							options={{
								layout      : "fitColumns",
								height      : "270px",
								placeholder : "No Data Found",
							}}
							className="responsive-tabulator"
						/>
					{/* <hr></hr> */}
						<h5 className='p-2'>• {t(`REPORT.지점별`, { defaultValue: '지점별' })}</h5>
						<ReactTabulator
							key={i18n.language + JSON.stringify(columns5)}
							onRef={(r) => (tableRef.current = r.current)}
							columns={columns5} // 다중 헤더 배열을 flat() 함수로 평평하게 만들어 전달합니다.
							data={responseData6}
							options={{
								layout      : "fitColumns",
								height      : "270px",
								placeholder : "No Data Found",
							}}
							className="responsive-tabulator"
						/>
					<hr></hr>					
				</div>

				
				{/* 로딩 관련 gif  */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}
			</Card.Body>
			<div className="card-footer d-flex justify-content-start mt-auto">
				{/* <button type="button" className="btn btn-outline-info mb-1 me-1 w-100px">버튼1</button>
				<button type="button" className="btn btn-outline-success me-1 mb-1 w-100px">버튼2</button> */}
			</div>
			
		</ Card>
	);
};

export default Report001;